/* PEONLY Startseite (aus demo-v4): Einblenden, Hero-Parallax, Sortiment-Karten, Scroll-Story, Teaser-Neigung, Warteliste.
   Funktioniert mit mehreren Abschnitten und im Theme-Editor (shopify:section:load / unload). */
(function(){
  if (window.PeonlyStart) return;
  var W = window, D = document;
  var rm = W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v){ return v < 0 ? 0 : v > 1 ? 1 : v; }
  function sm(v){ v = clamp(v); return v * v * (3 - 2 * v); }
  function q(r, s){ return r.querySelector(s); }
  function qa(r, s){ return [].slice.call(r.querySelectorAll(s)); }
  var comps = [], raf = 0, io = null;

  function reveal(root){
    var els = qa(root, '[data-pe-rv]');
    if (rm || !('IntersectionObserver' in W) || D.documentElement.classList.contains('pe-dm')) { els.forEach(function(e){ e.classList.add('pe-in'); }); return; }
    if (!io) io = new IntersectionObserver(function(es){ es.forEach(function(e){
      if (e.isIntersecting) { e.target.classList.add('pe-in'); io.unobserve(e.target); }
    }); }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function(e){ io.observe(e); });
  }

  /* Höhe des fixierten North-Headers (für Hero-Höhe und Sticky-Story) */
  var hdrSel = 'theme-header, .header-section .header, .shopify-section-group-header-group header';
  function headerBottom(){
    var best = 0;
    qa(D, hdrSel).forEach(function(h){
      var cs = getComputedStyle(h);
      if (cs.position === 'fixed' || cs.position === 'sticky') { var b = h.getBoundingClientRect(); if (b.bottom > best && b.bottom < innerHeight * .4) best = b.bottom; }
    });
    var sec = q(D, '.shopify-section-group-header-group');
    if (!best && sec && getComputedStyle(sec).position === 'sticky') best = sec.getBoundingClientRect().bottom;
    return Math.max(0, Math.round(best));
  }

  var init = {
    hero: function(r){
      var bg = q(r, '.pe-hero-bg'), hin = q(r, '.pe-hero-in');
      function top(){ var t = r.getBoundingClientRect().top + W.scrollY; r.style.setProperty('--pe-top', Math.max(0, Math.min(220, Math.round(t))) + 'px'); }
      top(); W.addEventListener('load', top);
      return { r: r, frame: function(y, vh){
        if (rm || y > vh * 1.2) return;
        var o = r.offsetTop, k = Math.max(0, y - (o > vh ? o : 0));
        bg.style.transform = 'translate3d(0,' + (k * .35).toFixed(1) + 'px,0)';
        hin.style.transform = 'translate3d(0,' + (-k * .12).toFixed(1) + 'px,0)';
        hin.style.opacity = clamp(1 - k / (vh * .75)).toFixed(3);
      }, resize: top };
    },
    sortiment: function(r){
      var row = q(r, '.pe-kp-row'), cards = qa(r, '.pe-kp'), dots = qa(r, '.pe-dots i');
      function act(c){ cards.forEach(function(x){ x.classList.toggle('pe-on', x === c); }); }
      cards.forEach(function(c){ c.addEventListener('mouseenter', function(){ act(c); }); c.addEventListener('focus', function(){ act(c); }); });
      if ('IntersectionObserver' in W) {
        var ko = new IntersectionObserver(function(es){ es.forEach(function(e){
          e.target.classList.toggle('pe-cur', e.isIntersecting);
          if (e.isIntersecting) { var i = cards.indexOf(e.target); dots.forEach(function(d, j){ d.classList.toggle('pe-on', i === j); }); }
        }); }, { root: row, threshold: .6 });
        cards.forEach(function(c){ ko.observe(c); });
      }
      return null;
    },
    story: function(r){
      var st = q(r, '.pe-st'), figs = qa(r, '.pe-st-media figure'), steps = qa(r, '.pe-st-step'), bars = qa(r, '.pe-st-bar button'), no = q(r, '.pe-big span');
      var n = Math.max(1, steps.length), cur = -1, hh = -1;
      bars.forEach(function(b){ b.addEventListener('click', function(){
        var t = st.getBoundingClientRect().top + W.scrollY - headerBottom(), span = st.offsetHeight - W.innerHeight;
        W.scrollTo({ top: t + span * (+b.getAttribute('data-i') + .5) / n, behavior: rm ? 'auto' : 'smooth' });
      }); });
      return { r: r, frame: function(y, vh, hb){
        if (hb !== hh) { hh = hb; r.style.setProperty('--pe-hh', hb + 'px'); }
        var b = st.getBoundingClientRect(); if (b.bottom < -vh || b.top > vh * 2) return;
        var p = clamp((hb - b.top) / (b.height - vh)), L = p * n;
        for (var i = 0; i < figs.length; i++) {
          var rev = i ? clamp((L - i + .3) / .5) : 1, img = figs[i].firstElementChild;
          if (i) figs[i].style.clipPath = 'inset(' + ((1 - rev) * 100).toFixed(2) + '% 0 0 0)';
          if (!rm && img) img.style.transform = 'scale(' + (1.18 - .18 * clamp(L - i + .3)).toFixed(4) + ')';
        }
        var a = Math.min(n - 1, Math.floor(L + .05));
        bars.forEach(function(x, j){ x.style.setProperty('--f', clamp(L - j).toFixed(3)); });
        if (a !== cur) { cur = a;
          steps.forEach(function(s, j){ s.classList.toggle('pe-on', j === a); });
          bars.forEach(function(x, j){ x.classList.toggle('pe-on', j === a); });
          if (no) no.textContent = (a < 9 ? '0' : '') + (a + 1);
        }
      } };
    },
    teaser: function(r){
      if (!rm && W.matchMedia('(hover: hover) and (pointer: fine)').matches) qa(r, '.pe-tz').forEach(function(c){
        c.addEventListener('pointermove', function(e){ var b = c.getBoundingClientRect(), x = (e.clientX - b.left) / b.width - .5, y = (e.clientY - b.top) / b.height - .5;
          c.classList.add('pe-tilt'); c.style.setProperty('--ry', (x * 6).toFixed(2) + 'deg'); c.style.setProperty('--rx', (-y * 5).toFixed(2) + 'deg'); });
        c.addEventListener('pointerleave', function(){ c.classList.remove('pe-tilt'); c.style.setProperty('--rx', '0deg'); c.style.setProperty('--ry', '0deg'); });
      });
      return null;
    },
    warteliste: function(r){
      var wait = q(r, '.pe-wait') || r, yr = q(r, '.pe-yr'), posted = !!q(r, '[data-posted]');
      if (posted) setTimeout(function(){ wait.scrollIntoView({ block: 'center' }); }, 60);
      if (yr && !rm && !posted && 'IntersectionObserver' in W) {
        var to = +yr.getAttribute('data-to');
        if (to > 9) { var from = to - 9; yr.textContent = from;
          var yo = new IntersectionObserver(function(es){ if (!es[0].isIntersecting) return; yo.disconnect();
            var t0 = null; W.requestAnimationFrame(function tick(now){ if (t0 === null) t0 = now; var k = Math.min(9, Math.floor((now - t0) / 110)); yr.textContent = from + k; if (k < 9) W.requestAnimationFrame(tick); });
          }, { threshold: .6 });
          yo.observe(yr);
        }
      }
      var f = q(r, '.pe-form');
      if (f) f.addEventListener('submit', function(){ var b = f.querySelector('button'); if (b) { b.disabled = true; b.style.opacity = '.7'; } });
      var wbs = qa(r, '.pe-wb').map(function(w, i){ var b = w.firstElementChild; return { w: w, b: b, f: b.firstElementChild, k: b.lastElementChild, dl: i * .12, dir: w.classList.contains('pe-wb-r') ? 1 : -1 }; });
      if (!wbs.length) return null;
      return { r: r, frame: function(y, vh){
        var wr = wait.getBoundingClientRect(); if (wr.top > vh * 1.5 || wr.bottom < -vh) return;
        var bp = rm ? 1 : clamp((vh - wr.top) / (vh * .9));
        for (var k = 0; k < wbs.length; k++) { var w = wbs[k], b = sm((bp - .3 - w.dl) / .62);
          w.w.style.transform = 'translate3d(' + (w.dir * -60 * (1 - b)).toFixed(1) + 'px,' + (40 * (1 - b)).toFixed(1) + 'px,0)';
          w.b.style.transform = 'scale(' + (.5 + .5 * b).toFixed(3) + ') rotate(' + (w.dir * 38 * (1 - b)).toFixed(1) + 'deg)';
          w.f.style.opacity = clamp((b - .05) * 2).toFixed(3); w.k.style.opacity = clamp(1 - (b - .35) * 2.4).toFixed(3);
          w.k.style.transform = 'scale(' + (1.65 - b * .35).toFixed(3) + ')'; }
      } };
    }
  };

  function frame(){
    raf = 0;
    comps = comps.filter(function(c){ return c.r.isConnected; });
    var y = W.scrollY, vh = W.innerHeight, hb = headerBottom();
    comps.forEach(function(c){ if (c.frame) c.frame(y, vh, hb); });
  }
  function kick(){ if (!raf) raf = W.requestAnimationFrame(frame); }

  function setup(scope){
    qa(scope, '[data-pe]').forEach(function(r){
      if (r.__pe) return; r.__pe = 1;
      reveal(r);
      var fn = init[r.getAttribute('data-pe')], c = fn ? fn(r) : null;
      if (c) comps.push(c);
    });
    kick();
  }

  W.PeonlyStart = { setup: setup };
  function go(){ setup(D); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', go); else go();
  W.addEventListener('scroll', kick, { passive: true });
  W.addEventListener('resize', function(){ comps.forEach(function(c){ if (c.resize) c.resize(); }); kick(); }, { passive: true });
  D.addEventListener('shopify:section:load', function(e){ setup(e.target); });
  D.addEventListener('shopify:block:select', function(e){
    var s = e.target.closest && e.target.closest('.pe-st-step');
    if (s && s.parentNode) { var i = [].indexOf.call(s.parentNode.children, s), r = s.closest('[data-pe]'), b = r && r.querySelectorAll('.pe-st-bar button')[i]; if (b) b.click(); }
    var k = e.target.closest && e.target.closest('.pe-kp'); if (k) k.dispatchEvent(new Event('mouseenter'));
  });
})();
